import React from "react";
import STRATEGIC_PARTNER from "../constants/strategicPartners";

const PaperCheckInstructions = ({strings}) =>
    (
        <div>
            <p>{strings.paymentRequired.preferToMailInA}</p>
            <p>{strings.paymentRequired.checksShouldBe}</p>
            <p>
                <span className="pineGreenText" style={{fontWeight: "bold"}}>{strings.paymentRequired.mailTo}</span><br/>
                {STRATEGIC_PARTNER.LEGAL.SERVICE_NAME}<br/>
                P.O. Box 735880<br/>
                Dallas, TX, 75373-5880
            </p>
            <a href>{strings.paymentRequired.downloadPDF}</a>
        </div>
    )

export default PaperCheckInstructions;
